import { render, staticRenderFns } from "./AllCategory.vue?vue&type=template&id=5a4286c1&scoped=true&"
import script from "./AllCategory.vue?vue&type=script&lang=js&"
export * from "./AllCategory.vue?vue&type=script&lang=js&"
import style0 from "./AllCategory.vue?vue&type=style&index=0&id=5a4286c1&prod&lang=scss&scoped=true&"
import style1 from "./AllCategory.vue?vue&type=style&index=1&id=5a4286c1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4286c1",
  null
  
)

export default component.exports